export enum DBObject {
  Inquiry = 'DBObjects::Inquiry',
  Invoice = 'DBObjects::Invoice',
  Guest = 'DBObjects::Guest',
  Incident = 'DBObjects::Incident',
  Task = 'DBObjects::Task',
  Charge = 'DBObjects::Charge',
  Extra = 'DBObjects::Extras',
  Expense = 'DBObjects::Expense',
  Rental = 'DBObjects::Rental',
  Card = 'DBObjects::Card',
  Inventory = 'DBObjects::Inventory',
  SecurityDeposit = 'DBObjects::SecurityDeposit',
}
